import React from "react";
import styled from "@emotion/styled";
import { Grid, Box } from "@mui/material";
import purify from "dompurify";

import SimpleResponsivePicture from "./SimpleResponsivePicture";
import StrapiGrid from "./StrapiGrid";
// import StrapiGridItemDanger from "./StrapiGridItemDanger";
import { addClassToLinksInParagraphs } from "./Functions";
import BioModal from "./BioModal";

export default function TenantRelations(props) {
  const imageBlockStyle = props?.options?.imageBlockStyle || {};
  const textBlockStyle = props?.options?.textBlockStyle || {};
  const { justifyContent, alignContent, columnGap, wrap, ...layoutOptions } =
    props?.options?.layout || false;
  const { sx } = textBlockStyle.innerStyles;
  const layout = props?.options.layout || {};

  let result = props.Copy;
  if (layout?.useButtonForLink) {
    result = addClassToLinksInParagraphs(result, "button", "_blank");
  }

  return (
    <StrapiGrid options={props?.options?.layout}>
      <Grid
        xs={12}
        md={props?.options?.layout?.imageSize || 4}
        item
        container
        alignItems="center"
        sx={{ ...imageBlockStyle }}
      >
        <SimpleResponsivePicture
          sx={{ ...imageBlockStyle.imageStyle }}
          imageObj={props?.Image?.data?.attributes}
        />
      </Grid>

      <Wrapper id="tr-wrapper" {...textBlockStyle}>
        <Box
          id="tr-copy"
          dangerouslySetInnerHTML={{ __html: purify.sanitize(result) }}
          sx={{ sx, ...textBlockStyle?.innerStyles }}
          color={"#fff"}
        />
        <Box id="tr-modal" sx={{ ml: { xs: "2rem", md: 0 }, mr: { xs: "2rem", md: 0 } }}>
          <BioModal
            ExpandedText={props?.ExpandedText || "This is where the bio goes."}
            trigger={props.trigger}
            theme={props.theme}
            buttonStyle={{
              backgroundColor: "rgba(71, 76, 85, 1)",

              maxWidth: "100%",
              "&:hover": { backgroundColor: "#fff", color: "#37939b" },
            }}
          />
        </Box>
      </Wrapper>
    </StrapiGrid>
  );
}
const Wrapper = styled(Grid)`
  a:hover {
    color: ${props => props.theme.palette.secondary.main}!important;
  }
  a:visited {
    color: ${props => props.theme.palette.common.white}!important;
  }
`;
